import { param } from 'router/declarative/paramRegistry';
import { TABS, type Tab } from './consts';

const isTab = (value: string): value is Tab => TABS.some(tab => tab === value);

export const tabParam = param<Tab | undefined>({
  fromString: value => (isTab(value) ? value : undefined),
  toString: value => value ?? '',
});
